<template>
<v-flex>
  <v-flex >
    <v-menu
      ref="menu2"
      lazy
      :close-on-content-click="false"
      v-model="menu2"
      transition="scale-transition"
      full-width 
      mx-auto
      min-width="290px"
      :return-value.sync="date"
      class="mx-2"
    >
      <v-text-field
        slot="activator"
        label="Select Date"
        v-model="date"
        prepend-icon="event"
        readonly
      ></v-text-field>
      <v-date-picker v-model="date" @input="$refs.menu2.save(date); logDate();"></v-date-picker>
    </v-menu>
    <v-list>
      <v-list-tile v-for="(aspect,i) in displayAspects" :key="i">
        <v-list-tile-avatar class='headline'>{{aspect.value}}</v-list-tile-avatar>
        <v-list-tile-title>{{aspect.name}}</v-list-tile-title>
        <v-list-tile-sub-title v-if="aspect.subtitle">{{aspect.subtitle}}</v-list-tile-sub-title>
      </v-list-tile> 
    </v-list>
  </v-flex>

  <v-toolbar flat> <v-toolbar-title>Export Data</v-toolbar-title></v-toolbar>
  <v-card dark color="white" class="mb-5 pa-4" flat>
    <v-card-text class="black--text  mt-4 text-xs-center" v-if="false">This chart includes all activities logged in {{appTitle}}</v-card-text>
    <v-card-text class="black--text text-xs-center">
      <v-btn small round color="info"
        v-for="aspect in downloadAspects"
        :key="aspect.safeName"
        @click="exportAspect(aspect)">
        {{aspect.name}}
      </v-btn>
      <v-btn small round color="info" @click="exportForDataStudio">Data Studio Aggregate</v-btn>
    </v-card-text>
    <v-data-table light flat class="mt-0" 
      :loading="loading" v-if="false"
      :headers="headers" :items="allActivities" v-model="allActivities"
      hide-actions :pagination.sync="pagination"
      @load="onUpdate(allActivities, function(data){ allActivities=data;});"
    >
      <template slot="headerCell" slot-scope="props" class="dark">
        <v-tooltip bottom>
          <span slot="activator">
            {{ props.header.text }}
          </span>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
      </template>
      <template slot="items" slot-scope="props">
        <td >{{ props.item.activityType }}</td>
        <td class="">{{ formatDateToString(new Date(parseInt(props.item.actDate))) }}</td>
        <td class="">{{ props.item.username }}</td>
        <td class="">{{ props.item.intensity }}</td>
        <td class="">{{ props.item.value }}</td>
        <td class="">{{ props.item.notes }}</td>
      </template>
    </v-data-table>           
  </v-card> 
   
</v-flex>
</template>

<script>
  
  /* globals localStorage File location */

  import GetActivityByUserQuery from '../queries/GetActivityByUserQuery'
  import ListActivitiesByUserQuery from '../queries/ListActivitiesByUserQuery'
  import ListActivitiesQuery from '../queries/ListActivitiesQuery'
  import ListUsersQuery from '../queries/ListUsersQuery'
  import AppConst from '../AppConst.js'

  const msPerDay = 1000 * 60 * 60 * 24

  var todayStringDate = new Date()
  var todayString = formatDateToString(todayStringDate)

  function filterForActivities (items) {
    return items.filter(item => item.activityType !== 'NapTaken')
      .filter(item => item.activityType !== 'WaterConsumption')
      .filter(item => item.activityType !== 'VoiceCeilingPitch')
      .filter(item => item.activityType !== 'VoiceFeeling')
      .filter(item => item.activityType !== 'HelpAdminText')
      .filter(item => item.activityType !== 'Sick')
  }
  function createFilterForType (activityType) {
    return function (items) {
      return items.filter(item => item.activityType === activityType)
    }
  }

  function formatDateToString (date) {
    var dd = (date.getDate() < 10 ? '0' : '') + date.getDate()
    var MM = ((date.getMonth() + 1) < 10 ? '0' : '') + (date.getMonth() + 1)
    var yyyy = date.getFullYear()

    // create the format you want
    return (yyyy + '-' + MM + '-' + dd)
  }

  function totalCombineValuesAll (data) {
    var newList = data
    var duplicates = []
    var ch = newList.filter(function (elem) {
      if (elem.id === 'HelpAdminText') {
        return false
      } else if (duplicates.includes(elem.id)) {
        return true
      } else {
        duplicates.push(elem.id)
        return true
      }
    })

    return ch
  }

  function listActivitiesAll (that, soFar = [], nextToken = null) {
    that.$apollo.query({
      variables: {
        username: localStorage.subID,
        first: 2000,
        after: nextToken
      },
      query: ListActivitiesQuery
    }).then(function logData (data) {
      console.log(nextToken ? 'loading more data...' : 'loading data...')
      var temp = data.data.listActivities
      if (temp.nextToken) {
        listActivitiesAll(that, soFar.concat(temp.items), temp.nextToken)
      } else {
        console.log('loaded!')
        that.allActivities = totalCombineValuesAll(soFar.concat(temp.items))
        that.listUserDataAll()
      }
    }).catch(err => {
      console.log(err.code)
      if (err.code === 'ProvisionedThroughputExceededException') {
        console.log('throughput throttled...')
        setTimeout(() => listActivitiesAll(that, soFar, nextToken), 1000)
      } else {
        console.error(err)
      }
    })
  }

  function unitsUsedCalculator (acts) {
    if (acts == null) return null

    let activities = filterForActivities(acts)
    let feeling = createFilterForType('VoiceFeeling')(acts)
    let naps = createFilterForType('NapTaken')(acts)

    if (activities.length === 0) {
      return null
    }

    let napValue
    if (feeling.length === 0) {
      napValue = 1
    } else {
      napValue = AppConst.voiceFeelDefaults.find(feel => feel.text === feeling[0].intensity).napValue
    }
    let spent = activities.reduce((acc, act) => acc + act.value, 0) - (napValue * naps.length)
    return Math.max(0, spent)
  }

  export default {
    data () {
      let minActiveDays = 10
      return {
        console,
        title: '',
        date: todayString,
        GetActivityByUserQuery: GetActivityByUserQuery,
        ListActivitiesByUserQuery: ListActivitiesByUserQuery,
        ListActivitiesQuery: ListActivitiesQuery,
        headers: [
          { text: 'Activity', align: 'left', value: 'activityType' },
          { text: 'Date', align: 'left', value: 'actDate' },
          { text: 'Username', align: 'left', value: 'username' },
          { text: 'Intensity', align: 'left', value: 'intensity' },
          { text: 'Value', align: '', value: 'value' },
          { text: 'Notes', align: 'left', value: 'notes' }
        ],
        minActiveDays,
        // TODO: move to calculated
        displayAspects: [
          {
            name: 'Active users in last 30 days',
            subtitle: `Counts users who have used the app at least ${minActiveDays} days of the last 30`,
            value: '...',
            valfunc: function () {
              const hour = 1000 * 60 * 60
              let everyone = {}
              Object.keys(this.userData.users).forEach(username => {
                if (username[0] === '_') return // watching out for __ob__
                let user = this.userData.users[username]
                everyone[username] = this.userData.dates.slice(-30).map(date => {
                  let acts = user[date] || user[date - hour] || user[date + hour]
                  if (acts == null) return 0
                  return !!acts.length - 0
                })
              })
              let participated = Object.values(everyone).filter(days =>
                days.reduce((acc, val) => acc + val) >= this.minActiveDays
              )
              return participated.length
            }
          },
          {
            name: 'Total Active Users',
            subtitle: `Counts all users who have ever used the app at least ${minActiveDays} days in a 30-day period`,
            value: '...',
            valfunc: function (acts) {
              const hour = 1000 * 60 * 60
              let everyone = {}
              Object.keys(this.userData.users).forEach(username => {
                if (username[0] === '_') return // watching out for __ob__
                let user = this.userData.users[username]
                everyone[username] = this.userData.dates.map(date => {
                  let acts = user[date] || user[date - hour] || user[date + hour] || []
                  return +!!acts.length
                })
              })
              let participated = Object.values(everyone).filter(days => {
                let runningDays = 0
                for (let i = 0; i < days.length; i++) {
                  if (i >= 30) { runningDays -= days[i - 30] }
                  runningDays += days[i]
                  if (runningDays >= this.minActiveDays) {
                    return true
                  }
                }
                return false
              })
              return participated.length
            }
          },
          {
            name: 'Total Users',
            subtitle: `Counts users who have used the app at least once`,
            value: '...',
            valfunc: function (acts) {
              return Object.keys(this.userData.users).filter(key => !key.startsWith('_')).length
            }
          }
        ],
        downloadAspects: [
          {
            name: 'Voice Function (Units Budgeted)',
            safeName: 'VoiceUnitsBudgeted',
            filterer: createFilterForType('VoiceFeeling'),
            valfunc: acts => acts[0].value
          }, {
            name: 'Units Used',
            safeName: 'VoiceUnitsUsed',
            filterer: filterForActivities,
            valfunc: acts => acts.reduce((acc, act) => acc + act.value, 0)
          }, {
            name: 'Units Used Minus Vocal Naps',
            safeName: 'VoiceUnitsUsedNaps',
            filterer: null,
            valfunc: null,
            substitute: unitsUsedCalculator
          }, {
            name: 'Ceiling Pitch (Midi Value)',
            safeName: 'MidiCeilingPitch',
            filterer: createFilterForType('VoiceCeilingPitch'),
            valfunc: acts => acts[0].value
          }, {
            name: 'Water Consumption',
            safeName: 'WaterConsumptionOz',
            filterer: createFilterForType('WaterConsumption'),
            valfunc: acts => acts.reduce((acc, act) => acc + act.value, 0)
          }, {
            name: 'Vocal Naps',
            safeName: 'VocalNaps',
            filterer: createFilterForType('NapTaken'),
            valfunc: acts => acts.length
          }, {
            name: 'Sick Days',
            safeName: 'SickDays',
            filterer: createFilterForType('Sick'),
            valfunc: acts => !!acts.length
          }
        ],
        allActivities: [],
        pagination: { 'sortBy': 'value', 'descending': true, 'rowsPerPage': 100 },
        date2: null,
        menu: false,
        modal: false,
        menu2: false,
        userData: null,
        UserDataMaster: [],
        chartDataUnitsVsVoiceFeeling: [],
        appTitle: AppConst.appTitle,
        loading: true
      }
    },
    methods: {
      async listUserDataAll () {
        try {
          let userProfiles = await this.$apollo.query({
            variables: {
              username: localStorage.subID
            },
            query: ListUsersQuery
          })

          const userData = (this.userData = { users: {}, dates: [] })
          const dates = userData.dates
          // let minDate = null
          // let maxDate = null

          this.allActivities.forEach(act => {
            if (!userData.users.hasOwnProperty(act.username)) {
              userData.users[act.username] = {} // dict of date:[activities]
            }

            let user = userData.users[act.username]
            let actDate = +act.actDate

            if (!user.hasOwnProperty(actDate)) {
              user[actDate] = []
            }
            // if (minDate === null) {
            //   minDate = maxDate = actDate
            // } else if (actDate < minDate) {
            //   minDate = actDate
            // } else if (actDate > maxDate) {
            //   maxDate = actDate
            // }

            let index = dates.findIndex(d => (d >= actDate))
            if (index === -1) {
              index = dates.length
            }
            if (dates[index] !== actDate) {
              dates.splice(index, 0, actDate)
            }

            user[actDate].push(act)
          })

          Object.keys(this.userData.users).forEach(username => {
            this.userData.users[username].profile = userProfiles.data.listUsers.items.find(
              user => user.id === username
            )
          })

          // let enumerDate = new Date(minDate)
          // while (enumerDate <= maxDate) { // eslint-disable-line
          //   userData.dates.push(+enumerDate)
          //   enumerDate.setDate(enumerDate.getDate() + 1)
          // }

          this.displayAspects.forEach(aspect => {
            aspect.value = aspect.valfunc.bind(this)(this.allActivities)
          })
        } catch (e) { console.error(e) }
        this.loading = false
      },
      exportAspect (opts) {
        let result = {}
        let sub = opts.filterer == null
        Object.keys(this.userData.users).forEach(username => {
          if (username[0] === '_') return // watching out for __ob__
          let user = this.userData.users[username]
          result[username] = this.userData.dates.map(date => {
            if (sub) {
              return opts.substitute(user[date])
            } else {
              if (user[date] == null) return null
              let filtered = opts.filterer(user[date])
              if (filtered.length === 0) return null
              return opts.valfunc(filtered)
            }
          })
          result[username].unshift(username)
        })

        let csvHeader = ['User'].concat(this.userData.dates.map(timeStamp =>
          formatDateToString(new Date(timeStamp)))
        )
        let csv = '' + csvHeader
        Object.keys(result).forEach(username => {
          csv += '\n' + result[username]
        })

        let el = document.createElement('a')
        el.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(csv))
        el.setAttribute('download', opts.safeName + '.csv')
        el.style.display = 'none'
        document.body.appendChild(el)
        el.click()
        document.body.removeChild(el)
      },
      exportForDataStudio () {
        let result = []
        let profileAspects = [
          { name: 'Age', key: 'Age' },
          { name: 'Gender', key: 'gender' },
          { name: 'Goals', key: 'goals' },
          { name: 'Descriptives', key: 'voiceDescriptives' },
          { name: 'Pursuit', key: 'voicePursuit' },
          { name: 'Voice Type', key: 'voiceType' }
        ]

        let dates = this.userData.dates

        Object.keys(this.userData.users).forEach(username => {
          if (username[0] === '_') { return }
          let user = this.userData.users[username]
          if (user.profile == null) { return }
          let minDateIndex
          let maxDateIndex
          for (let i = 0; i < dates.length && minDateIndex === undefined; i++) {
            if (user[dates[i]] !== undefined) { minDateIndex = i }
          }
          for (let i = dates.length - 1; i >= 0 && maxDateIndex === undefined; i--) {
            if (user[dates[i]] !== undefined) { maxDateIndex = i }
          }
          if (minDateIndex === undefined) { return }
          let userDates = dates.slice(minDateIndex, maxDateIndex)
          let lastActivity = 0

          userDates.forEach(date => {
            let usernameDateResult = this.downloadAspects.map(opts => {
              if (opts.filterer == null) {
                return opts.substitute(user[date])
              } else {
                if (user[date] == null) return null
                let filtered = opts.filterer(user[date])
                if (filtered.length === 0) return null
                return opts.valfunc(filtered)
              }
            })
            if (usernameDateResult[0] != null) {
              lastActivity = new Date(date)
              usernameDateResult.push(0)
            } else if (lastActivity != null) {
              usernameDateResult.push(
                ((new Date(date)) - lastActivity) / msPerDay
              )
            } else {
              usernameDateResult.push(null)
            }
            if (user.profile) {
              profileAspects.forEach(aspect => usernameDateResult.push('"' + user.profile[aspect.key] + '"'))
            } else {
              profileAspects.forEach(aspect => usernameDateResult.push(null))
            }
            result.push([username, formatDateToString(new Date(date))].concat(usernameDateResult))
          })
        })
        let csvHeader = ['User', 'Date'].concat(this.downloadAspects.map(opts => opts.name))
        csvHeader.push('Days Since Last Activity')
        profileAspects.forEach(aspect =>
          csvHeader.push(aspect.name)
        )
        let csv = csvHeader + '\n' + result.join('\n')

        let file = new File([csv], 'SingerSavvyDataStudio.csv', { type: 'text/csv' })
        let url = URL.createObjectURL(file)
        location.assign(url)
        let el = document.createElement('a')
        el.setAttribute('href', url)
        el.setAttribute('download', 'SingerSavvyDataStudio.csv')
        el.style.display = 'none'
        document.body.appendChild(el)
        el.click()
        document.body.removeChild(el)
        URL.revokeObjectURL(url)
      },
      formatDateToString
    },
    mounted () {
      // this fetches activities for the list
      this.displayAspects.forEach(aspect => { aspect.valfunc = aspect.valfunc.bind(this) })
      listActivitiesAll(this)
    },
    props: [
      'postTitle',
      'postFeelings',
      'postType'
    ]
  }
</script>



// WEBPACK FOOTER //
// src/components/stats/DataTableStatsAdmin.vue